module.exports = __webpack_public_path__ + "ed87586be8175f965a7e819360ea97a1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/earrings-ruby.png
// module id = 2187
// module chunks = 0